import { render, staticRenderFns } from "./DraftAction.vue?vue&type=template&id=f9881422&"
import script from "./DraftAction.vue?vue&type=script&lang=js&"
export * from "./DraftAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports